import { type RootState } from "~/redux/store";
import { getWishlists } from "~/Wishlist/redux/wishlistSelectors";

export const selectShareableWishlists = (state: RootState) => {
  return getWishlists(state.wishlistPage).filter((wishlist) => wishlist.entryIds.length > 0);
};
